import { doc, onSnapshot, serverTimestamp, setDoc } from 'firebase/firestore';
import { firestore } from '../firebase';

export const DEFAULT_ATTENDANCE_SETTINGS = {
  officeStartTime: '10:00',
  halfDayCutoffTime: '12:30',
  attendanceCloseTime: '',
  autoAbsent: true,
  allowOffice: true,
  allowClient: true,
  geoAttendanceEnabled: false,
  geoAccuracyMeters: 500,
  maxAcceptedGpsAccuracyMeters: 150,
  offices: [],
  adminCorrectionEnabled: true,
};

function normalizeOffices(offices = []) {
  return offices.slice(0, 5).map((office, index) => ({
    id: office.id || `office-${index + 1}`,
    name: office.name || '',
    address: office.address || '',
    latitude: office.latitude === '' || office.latitude == null ? '' : Number(office.latitude),
    longitude: office.longitude === '' || office.longitude == null ? '' : Number(office.longitude),
    radiusMeters: Number(office.radiusMeters || 500),
    active: office.active !== false,
  }));
}

export function subscribeAttendanceSettings(onData, onError) {
  return onSnapshot(doc(firestore, 'appSettings', 'attendance'), (snapshot) => {
    const values = { ...DEFAULT_ATTENDANCE_SETTINGS, ...(snapshot.exists() ? snapshot.data() : {}) };
    onData({ ...values, offices: normalizeOffices(values.offices) });
  }, onError);
}

export async function saveAttendanceSettings(values, userId) {
  await setDoc(doc(firestore, 'appSettings', 'attendance'), {
    ...DEFAULT_ATTENDANCE_SETTINGS,
    ...values,
    geoAccuracyMeters: Number(values.geoAccuracyMeters || 500),
    maxAcceptedGpsAccuracyMeters: Number(values.maxAcceptedGpsAccuracyMeters || 150),
    offices: normalizeOffices(values.offices),
    updatedAt: serverTimestamp(),
    updatedById: userId || '',
  }, { merge: true });
}
